import { Moment } from 'moment';
import Entity from '../interfaces/IEntity';

export default class Daterange implements Entity {
  constructor(public id?: string, public start?: Moment, public end?: Moment) {}
}
